import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LegalNotice from "@/pages/LegalNotice";
import CookieConsent from "@/components/CookieConsent";
import Dashboard from "@/pages/Dashboard";
import Game from "@/pages/Game";
import Results from "@/pages/Results";
import Statistics from "@/pages/Statistics";
import Challenge from "@/pages/Challenge";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

const withLayout = (el) => (
  <ProtectedRoute>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors offset={96} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
            <Route path="/" element={withLayout(<Dashboard />)} />
            <Route path="/jeu" element={withLayout(<Game />)} />
            <Route path="/resultats" element={withLayout(<Results />)} />
            <Route path="/challenge" element={withLayout(<Challenge />)} />
            <Route path="/profil" element={withLayout(<Profile />)} />
            <Route path="/statistiques" element={withLayout(<Statistics />)} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute staffOnly>
                  <Layout>
                    <Admin />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
